


































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad,TbShop } from '@/http';
import { NumberKeyboard,dialogPanel } from "@/components";
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
import { TbShopReceiptTemplate } from '@/http/api_TbShopReceiptTemplate';
import changeMbTip from "./changeMbTip.vue";
import calculate from '@/common/util/calculate';
import { tailFun } from "@/common/util/tail";
import {PrintEvent1, PrintEvent2,PrintEvent3} from "@/common/util/prints";
import JsBarcode from 'jsbarcode';
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({ 
    components: {
        NumberKeyboard,changeMbTip,dialogPanel
    },
})
export default class xpInfo extends Vue {
   
    public $refs: {
    };
    userInfo = {};
    isEdit = false;
    padSetInfo:any={};
    orderInfo={
        //   订单Id
        id:"",
        // 订单编号
        orderNo:'SY123456',	
        // 店铺ID
        shopId:'',
        // 订单状态
        // 0 = None，缺省值
        // 1 = Wait，待支付
        // 2 = Success，支付成功
        // 3 = Failed，支付失败
        // 4 = Closed，已关闭
        orderStatus:0,
        // 下单时间
        orderDate:'2023-09-28 12:30:45',	
        // 会员Id
        memberId:'6666',
        // 会员姓名
        memberName:'',
        // 会员等级名称
        gradeName:'',
        // 会员手机号
        memberPhone:'19768298698',
        // 商品数量
        num:4,
        // 商品总价
        goodsPrice:458,

        // 支付方式
        // 0 = None，缺省值
        // 1 = MemberCard，会员卡
        // 2 = Cash，现金
        // 3 = Wechat，微信
        // 4 = AliPay，支付宝
        // 5 = Cash_Card_WeChat，现金+会员卡+微信
        // 6 = Cash_Card_Alipay，现金+会员卡+支付宝
        // 7 = Cash_WeChat，现金+微信
        // 8 = Cash_Alipay，现金+支付宝
        // 9 = Card_WeChat，会员卡+微信
        // 10 = Card_Alipay，会员卡+支付宝
        // 11 = Cash_Card，现金+会员卡
        paymentMethod:2,
        // 支付类型
        // 0 = None，缺省值
        // 1 = WholeOrder，整单支付
        // 2 = Compose，组合支付
        paymentType:0,
        // 整单折扣
        orderDiscount:0.8,
        // 整单折扣优惠金额
        orderDiscountPrice: 20,
        // 会员折扣
        memberDiscount:	7.8,
        // 会员积分抵扣金额
        pointDeduction:	0,
        // 使用会员积分
        useIntegral:0,
        // 总折扣额(元)
        totalDiscountPrice:0,
        // 应收款
        receivables:458,
        // 实收款
        actualPayment:0,
        // 抹零
        erasePrice:0,
        // 抹零方式
        // 0 = None，缺省值
        // 1 = Yuan，抹零到元
        // 2 = Jiao，抹零到角
        roundType:0,
        // 合计(折后总价)
        totalAmount:458,
        // 商品折扣优惠
        orderGoodsDiscount:99,
        // 会员折扣优惠
        orderMemberDiscount:0,
        // 找零
        giveChange:20,
        // 现金支付金额
        cashPart:458,
        // 会员卡支付金额
        cardPart:100,
        // 微信支付金额
        weChatPart:0,	
        // 支付宝支付金额
        alipayPart:0,
        // 订单类型
        // 0 = None，缺省值
        // 1 = Sales，销售订单
        // 2 = Return，退货订单
        orderType:1,
        // 收银员id
        cashierId:'',
        // 收银员
        cashier:'张三',
        // 收银员员工号
        cashierNo:'22009',	
        // 创建时间
        createTime:'2023-09-28 12:30:45',
        // 是否删除
        isDelete:false,
        // 变动积分
        changeIntegral:100,
        // 是否整单折扣
        isWholeOrderDiscount:true,
        // 优惠券名称
        couponName:"此处显示该订单使用的优惠券名称",
        // 优惠券优惠金额
        couponPrice: 0,
        // 消费完剩余余额
        leftBalance:99012,
        // 消费完剩余积分
        leftIntegral:9019,
        // 消费完本次积分
        leftIntegral1:1000,
        // 会员卡退回金额
        cardPrice:null,
        // 线下退回金额
        offlinePrice:null,
        // 实退金额
        returnPrice:null,
        // 商品成本
        costPrice:null,
        // 销售利润
        profit:null,
        // 销售利润率
        profitRate:null,
        // 赠品优惠金额
        giftDiscountPrice:null,
        // 赠品数量
        giftNum:null,
        // 赠品总额
        giftAmount:null,
        remark:'此处显示订单的整单备注信息此处显示订单的整单备注信息此处显示订单的整单备注信息',

        // 订单子项
        items:[
        {
          
            articleNo:"230309342423301291",
            // 商品名称
            name:"商品名称长点效果韩式",
            // 商品分类
            goodsClassName:"",
            // 售价
            sellingPrice:199,
            // 是否参与打折
            isDiscount:true,
            // 是否参与会员打折
            isMemberDiscount:false,
            // 商品折扣价
            discountPrice:99,
            // 商品折扣
            goodDiscount:null,
            // 商品本身优惠(商品本身折扣+会员折扣)
            goodDiscountPrice:99,
            // 规格名称
            goodsSpecsName:"规格值1/规格值2/规格值3",
            /**数量 */
            num:1,
            // 最终总售价
            totalPrice:199,
            goodsDiscount:100,
            memberDiscount:0,
            isCoupon:true,

        },{
          
          articleNo:"230309342423301291",
          // 商品名称
          name:"商品名称长点效果韩式",
          // 商品分类
          goodsClassName:"",
          // 售价
          sellingPrice:199,
          // 是否参与打折
          isDiscount:false,
          // 是否参与会员打折
          isMemberDiscount:false,
          // 商品折扣价
          discountPrice:99,
          // 商品折扣
          goodDiscount:null,
          // 商品本身优惠(商品本身折扣+会员折扣)
          goodDiscountPrice:99,
          // 规格名称
          goodsSpecsName:"规格值1/规格值2/规格值3",
          /**数量 */
          num:1,
          // 最终总售价
          totalPrice:199,
          goodsDiscount:0,
            memberDiscount:0,
            isCoupon:false,
      },]
    }
    czpadSetInfo:any={
        // id:"",
        // type:null,
        settingContent:{
            businessHours:{
                isSelect:true,
                value:"",
            },
            cashier:{
                isSelect:true,
                value:"",
            },
            contactInfo:{
                isSelect:true,
                value:"",
            },
            currency:{
                isSelect:true,
                value:"",
            },
            dateTime:{
                isSelect:true,
                value:"",
            },
            goodsName:{
                isSelect:true,
                value:"",
            },
            member:{
                isSelect:true,
                value:"",
            },
            orderCode:{
                isSelect:true,
                value:"",
            },
            orderNumber:{
                isSelect:true,
                value:"",
            },
            payInfo:{
                isSelect:true,
                value:"",
            },
            qrCode:{
                isSelect:true,
                value:"",
            },
            shopInfo:{
                isSelect:true,
                value:"",
            },
            shopName:{
                isSelect:true,
                value:"",
            },
            welcomeMessage:{
                isSelect:true,
                value:"",
            },
            putNum:null,
            isPut:false,
            
        }
    };
    czorderInfo={
        //   订单Id
        id:"",
        // 订单编号
        orderNo:'SY123456',	
        // 店铺ID
        shopId:'',
        // 充值时间
        orderDate:'2023-09-28 12:30:45',	
        // 会员Id
        memberId:'6666',
        // 会员姓名
        memberName:'',
        // 会员等级名称
        gradeName:'',
        // 会员手机号
        memberPhone:'19768298698',
        // 支付方式
        // 0 = None，缺省值
        // 2 = Cash，现金
        // 3 = Wechat，微信
        // 4 = AliPay，支付宝
        paymentMethod:2,
        //收款金额
        receivedAmount:500,
        // 找零
        giveChange:20,
        // 收银员id
        cashierId:'',
        // 收银员
        cashierName:'张三',
        //充前金额
        originalAmount:100,
        //充值金额
        rechargeAmount:500,
        //赠送金额
        giftAmount:50,
        //赠送积分
        giftIntegral:100,
        //现有金额
        currentAmount:650,
        //现有积分
        currentIntegral:1200,
        address:'此处显示店铺中的详细地址',
    }
    receiptPrinterName = "";
    isPrintLoading = false;
    shopInfo:any = {};
    concatName="";
    concatPhone="";
    isLoading1 = false;
    //判断是否是销售小票新版本 1新 0旧
    isnewReceipt=0;

    putNum=1;
    isPut=true;
    editVal=1;
    /**预览 */
    previewShow = false;
    activeitem = 1;/**1:收银旧模版 2：充值旧模版 3:收银新模版 */

    //二维码
    QRCode = null
    qrcode = null
    QRCode1 = null
    qrcode1 = null
    calculate =calculate;
    tailFun =tailFun;

    preTit = "";

    usedForm:any={}

    //涉及到的系统数据
    defaultInfo=[
        {
        label:'门店Logo',
        value:'https://sinostoragedev.oss-cn-hangzhou.aliyuncs.com/fms/6474B268-FC5F-460C-8B4E-B652AA23CFB0.png'
        },
        {
        label:'门店名称',
        value:JSON.parse(localStorage.getItem('padShopInfo')).shopName
        },
        {
        label:'小票名称',
        value:'销售单'
        },
        {
        label:'订单编号',
        value:'SY123456'
        },
        {
        label:'销售日期',
        value:'2023-09-28 12:30:45'
        },
        {
        label:'销售商品明细',
        value:''
        },
        {
        label:'收银员',
        value:'22009 张三'
        },
        {
        label:'销售商品明细',
        value:''
        },
        {
        label:'销售商品小计',
        value:''
        },
        {
        label:'订单优惠明细',
        value:''
        },
        {
        label:'订单实收金额',
        value:'500.00'
        },
        {
        label:'订单支付明细',
        value:''
        },
        {
        label:'会员信息',
        value:''
        },
        {
        label:'联系人',
        value:JSON.parse(localStorage.getItem('padShopInfo')).name
        },
        {
        label:'联系电话',
        value:JSON.parse(localStorage.getItem('padShopInfo')).phone
        },
        {
        label:'地址',
        value:JSON.parse(localStorage.getItem('padShopInfo')).address
        },
    ]
    isloadingChange=false;

    created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }
    async activated() {
        console.log('xpxp');
        
        this.shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
        
    }
    async mounted(){
     
        this.shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
        await this.getInfo();
      
        this.$nextTick(()=>{
                this.editVal = this.isnewReceipt;
        })
    }
   
    finishNum(val,type){
        switch (type) {
            case 1:
                this.putNum=val;
                break; 
            case 2:
                this.czpadSetInfo.settingContent.putNum=val;
                break;         
            default:
                break;
        }
    }
    editInfo(){
        this.isEdit = true;
    }
    cancelInfo(){
        this.isEdit = false;
        localStorage.removeItem('isnewReceipt');
        this.getInfo();
    }
    async getInfo(){
        if(localStorage.getItem('isnewReceipt')){
            this.isnewReceipt = Number(localStorage.getItem('isnewReceipt'))
        }else{
            await this.getMbVersion();
        }
         await this.init();
    };
    async init(){
        if(this.isnewReceipt==0){
            await this.getOldSyInfo();
        }else{
            await this.getNewSyInfo();
        }
        
        await this.getCzInfo();
        
    }
    async getNewSyInfo(){
            let res = await TbShopReceiptTemplate.GetTbShopReceiptTemplate({
                shopNo:this.shopInfo.shopNo,
                shopId:this.shopInfo.id
            })
            if(res&&res.contentJson){
                this.padSetInfo = res;
                this.isPut = res.autoPrint;
                this.putNum = res.contentJson.receiptTemplateMore.printNum;
            }else{
                 this.padSetInfo =null;
            }
    }
    async getOldSyInfo(){
        let res = await TbSettingsPad.GetTbSettings({
                settingtype:5
            });
            res.settingContent.contactInfo = res.settingContent.contactInfo?res.settingContent.contactInfo:{
                index:0,
                isSelect:false,
                value:""
            } 
            res.settingContent.qrCode = res.settingContent.qrCode?res.settingContent.qrCode:{
                index:0,
                isSelect:false,
                value:""
            } 
            res.settingContent.remark=res.settingContent.remark?res.settingContent.remark:{
                index:0,
                isSelect:true,
                value:''
            };
            res.settingContent.receiptRemark=res.settingContent.receiptRemark?res.settingContent.receiptRemark:{
                index:0,
                isSelect:false,
                value:''
            };
            this.padSetInfo = res;
            if(this.padSetInfo.settingContent.contactInfo&&this.padSetInfo.settingContent.contactInfo.isSelect&&this.padSetInfo.settingContent.contactInfo.value){
            let arr = this.padSetInfo.settingContent.contactInfo.value?this.padSetInfo.settingContent.contactInfo.value.split(':'):[];
            if(arr.length>0){
                this.concatName=arr[0]
            }
            if(arr.length>=1){
                this.concatName=arr[0]
                this.concatPhone=arr[1]
            }
            }
            if(this.padSetInfo.settingContent.shopName){
                this.padSetInfo.settingContent.shopName.value=this.padSetInfo.settingContent.shopName.value?this.padSetInfo.settingContent.shopName.value:this.shopInfo['shopName'];
            }
            this.putNum = res.settingContent.putNum?res.settingContent.putNum:1;
            this.isPut = res.settingContent.isPut;
    }
    async getCzInfo(){
        let czRes = await TbSettingsPad.GetTbSettings({settingtype:6});
        czRes.settingContent.businessHours=czRes.settingContent.businessHours?czRes.settingContent.businessHours:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.currency=czRes.settingContent.currency?czRes.settingContent.currency:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.dateTime=czRes.settingContent.dateTime?czRes.settingContent.dateTime:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.member=czRes.settingContent.member?czRes.settingContent.member:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.orderNumber=czRes.settingContent.orderNumber?czRes.settingContent.orderNumber:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.payInfo=czRes.settingContent.payInfo?czRes.settingContent.payInfo:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.shopName=czRes.settingContent.shopName?czRes.settingContent.shopName:{
            index:0,
            isSelect:false,
            value:''
        };
        czRes.settingContent.welcomeMessage=czRes.settingContent.welcomeMessage?czRes.settingContent.welcomeMessage:{
            index:0,
            isSelect:false,
            value:''
        };
        this.czpadSetInfo = czRes;
    }
    async getMbVersion(){
        let res = await TbShop.GetInitShopInfo({shopid:this.shopInfo.id});
        this.isnewReceipt = res.webShopReceiptTemplateType;   
        
    }
    async saveEdit(){
        if(!this.putNum||Number(this.putNum==0)||!this.czpadSetInfo.settingContent.putNum||Number(this.czpadSetInfo.settingContent.putNum)==0){
            Toast("请输入打印份数");
            return
        }
        //销售小票
        if(this.isLoading1) return;
        this.isLoading1 = true;
        
        try {
            let type = this.isnewReceipt;
            console.log('type',type,this.isnewReceipt);
            
            this.czpadSetInfo.settingContent.putNum=this.czpadSetInfo.settingContent.putNum?this.czpadSetInfo.settingContent.putNum:1;
            await TbShop.PutWebShopReceiptTemplateType({shopid:this.shopInfo.id,shopno:this.shopInfo.shopNo,webShopReceiptTemplateType:type});
            if(this.isnewReceipt==0){
                 this.padSetInfo.settingContent.contactInfo.value=this.concatName||this.concatPhone?this.concatName+":"+this.concatPhone:'';
                if(this.padSetInfo.settingContent.contactInfo){
                    this.padSetInfo.settingContent.contactInfo.index=0;
                }
                this.padSetInfo.settingContent.putNum=this.putNum?this.putNum:1;
                this.padSetInfo.settingContent.isPut=this.isPut;
                await TbSettingsPad.PutTbSettings({
                    id:this.padSetInfo.id,
                    settingContent:JSON.stringify(this.padSetInfo.settingContent),
                })
            }else{
                let form = this.padSetInfo;
                let moreInfo = Object.assign({},form.contentJson.receiptTemplateMore,{printNum:this.putNum})
                await TbShopReceiptTemplate.PutShopReceiptTemplate({
                id:form.id,
                shopId:form.shopId,
                shopNo:form.shopNo,
                autoPrint:this.isPut,
                contentJson:{
                    receiptDatas:form.contentJson.receiptDatas,
                    receiptTemplateMore:moreInfo
                },
                arrayJson:JSON.stringify(form.arrayJson),
                })
            }
            await TbSettingsPad.PutTbSettings({
                id:this.czpadSetInfo.id,
                settingContent:JSON.stringify(this.czpadSetInfo.settingContent),
            })
            localStorage.removeItem('isnewReceipt');
            await this.getInfo();
            this.isLoading1 = false;
            this.isEdit = false;
            Toast('保存成功');
        } catch (error) {
            this.isLoading1 = false;
        }
        
    }
    changeAuto(type,val){
        if(!this.isEdit) return;
        if(type==1){
            this.isPut = val;
        }else{
            this.czpadSetInfo.settingContent.isPut = val;
        }
    }
    async printTest(activeitem){
        if(this.isPrintLoading) return;
         let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''
        if(activeitem==1){
            if(this.isnewReceipt==0){
                this.isPrintLoading = true;
                let resSetting= await TbSettingsPad.GetTbSettings({
                    settingtype: 5,
                });
                resSetting.settingContent.receiptRemark=resSetting.settingContent.receiptRemark?resSetting.settingContent.receiptRemark:{
                    index:0,
                    isSelect:false,
                    value:''
                };
                let form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfo:Object.assign({},this.orderInfo,{address:address})},{type:'receipt'});
                let time = 3000*resSetting.settingContent.putNum;
                if(form.settingContent.putNum>0){
                    for(let i =1;i<=form.settingContent.putNum;i++){
                        setTimeout(()=>{
                            const canvas = this.$refs['barcodeCanvas'];
                            JsBarcode('canvas', form.orderInfo.orderNo, {
                                format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                                lineColor: "#000",
                                width: 3,
                                height: 100,
                                displayValue: false
                            });
                            let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                            PrintEvent1(form,barcodeImage)
                        },3000)
                    }
                }
                setTimeout(()=>{
                    this.isPrintLoading = false;
                },time)
               
            }else{
                await this.printNew();
            }
        }else if(activeitem==2){
            this.isPrintLoading = true;
            let resSetting= await TbSettingsPad.GetTbSettings({
                settingtype: 6,
            });
            let form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfo:Object.assign({},this.czorderInfo,{address:address})},{type:'receipt',chargeFlag:'1'});
            let time = 3000*resSetting.settingContent.putNum;
            if(form.settingContent.putNum>0){
                for(let i =1;i<=form.settingContent.putNum;i++){
                    setTimeout(()=>{
                        PrintEvent2(form)
                    },3000)
                }
            }
            setTimeout(()=>{
                this.isPrintLoading = false;
            },time)
        }else if(activeitem==3){
            await this.printNew();
        }
    }
    async printNew(){
        this.isPrintLoading = true;
        let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''
        let res = await TbShopReceiptTemplate.GetTbShopReceiptTemplate({
            shopNo:this.shopInfo.shopNo,
            shopId:this.shopInfo.id
        })
        let padSetInfo= res;
        let form = Object.assign({},{settingContent:padSetInfo},{orderInfo:Object.assign({},this.orderInfo,{address:address})},{type:'receipt'});
        let putNum = res.contentJson.receiptTemplateMore.printNum?res.contentJson.receiptTemplateMore.printNum:1;
        let time = 3000*putNum;
        setTimeout(()=>{
            const canvas = this.$refs['barcodeCanvas'];
            JsBarcode('canvas', form.orderInfo.orderNo, {
                format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                lineColor: "#000",
                width: 3,
                height: 100,
                displayValue: false
            });
            let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
            PrintEvent3(form,barcodeImage,putNum)
        },3000)
        // if(this.putNum>0){
        //     for(let i =1;i<=form.settingContent.putNum;i++){
        //         setTimeout(()=>{
        //         },3000)
        //     }
        // }
        setTimeout(()=>{
            this.isPrintLoading = false;
        },time)
    }
    prePrintTest(){
        this.printTest(this.activeitem)
    }
    goXpSet(val){
        this.$emit('changeTab',{tabActive:3,childActive:val});
        localStorage.setItem("isnewReceipt",this.isnewReceipt.toString())
    }
    changeVersion(val){
        if(!this.isEdit) return;
        if(this.isloadingChange) return;
        if(this.editVal==val) return;
        this.editVal = val;
        if(val==1&&!localStorage.getItem('receiptNotTip')){
            this.$refs['changeMbTip'].showFun();
        }else{
            this.changeMbConfirm();
        }
    }
    async changeMbConfirm(){
        if(this.isloadingChange) return;
        this.isloadingChange = true;
        Toast.loading({
            message: "切换中...",
            duration: 0, // toast不消失
        })
        if(this.editVal==1){
            await this.getNewSyInfo();
            console.log('padSetInfo',this.padSetInfo);
            if(!this.padSetInfo){
                Toast({
                    duration:4000,
                    message:'微信搜索“航富通”小程序，进入[打印设置]，将打印模板切换至“新版本”！'
                });
                Toast.clear();
                this.isloadingChange = false;
            }else{
                this.isnewReceipt = this.editVal;
                this.init();
                Toast.clear();
                this.isloadingChange = false;
            }
        }else{
            this.isnewReceipt = this.editVal;
            this.init();
            Toast.clear();
            this.isloadingChange = false;
        }
    }
    closePreview(){
        this.previewShow = false;
    }
    async showPreview(type){
        if(type==2){
            this.preTit = "充值小票";
            this.activeitem = 2;
            await this.getCzInfo();
            this.previewShow = true;  
        }else{
            this.preTit = "收银小票";
            if(this.isnewReceipt==0){
                
                this.activeitem = 1;
                await this.getOldSyInfo();
                this.previewShow = true; 
                await this.clearQRCode();
                 console.log('this.padSetInfo',this.padSetInfo);
                let url = window.location.host.indexOf('test')>-1?`https://posm.hftopos.com/vipMpTest?shopId=${this.userInfo['shopId']}`:`https://posm.hftopos.com/vipMp?shopId=${this.userInfo['shopId']}`;
                console.log('url',url);
                
                this.$nextTick(()=>{
                    // this.getEwm(url);
                    this.getEwm1(url);
                })
            }else{
                this.activeitem = 3;
                await this.getNewSyInfo();
                this.usedForm = {};
                this.usedForm = Object.assign({},this.padSetInfo,this.usedForm);
                this.usedForm = Object.assign({},this.usedForm,{
                    list:this.usedForm.contentJson.receiptDatas.filter(v=>v.isSelect).sort((a, b) => a.index - b.index),
                    isPrintCurrency:this.usedForm.contentJson.receiptTemplateMore.isPrintCurrency,
                    labelCurrencyType:this.usedForm.contentJson.receiptTemplateMore.labelCurrencyType
                })
                this.previewShow = true; 
                await this.clearQRCode();
                 console.log('this.padSetInfo',this.padSetInfo);
                let url = window.location.host.indexOf('test')>-1?`https://posm.hftopos.com/vipMpTest?shopId=${this.userInfo['shopId']}`:`https://posm.hftopos.com/vipMp?shopId=${this.userInfo['shopId']}`;
                console.log('url',url);
                
                this.$nextTick(()=>{
                    // this.getEwm(url);
                    this.getEwm1(url);
                })
            }
        }
    }
    clearQRCode() {
        var qrcodeContainer = document.getElementById("SetQRCode");
        if(qrcodeContainer){
            this.qrcode = null;
            while (qrcodeContainer.hasChildNodes()) { // 清空所有子节点
            qrcodeContainer.removeChild(qrcodeContainer.lastChild);
            }
        }
    }
    getEwm1(val){
        let qrCode = val;
        this.QRCode1 = qrCode;
        let qrcodeDiv = document.getElementById("SetQRCode1")
        let qrcode = new QRCode(qrcodeDiv,{
            text:this.QRCode1,//二维码中的内容
            width:150,
            height:150,
            colorDark:"#000",//二维码颜色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
            }) 
        this.qrcode1 = qrcode;
        let childs = document.getElementById("SetQRCode1").childNodes;
        for(let i = childs.length -2 ; i>=0 ; i--){
            document.getElementById("SetQRCode1").removeChild(childs[i]);
        }
    }
    getFhname(type){
            let name = '';
            switch (type) {
                case 1:
                    name='￥';
                    break;
                case 2:
                    name='$';
                    break;
                case 3:
                    name='HK$';
                    break;
                case 4:
                    name='MOP$';
                    break;
                case 5:
                    name='RM';
                    break;
                case 6:
                    name='NT$';
                    break;
                case 7:
                    name='OMR';
                    break;
                case 8:
                    name='THB';
                    break;
                default:
                    break;
            }
            return name;
        }
   getVal(item){
            let str = "";
            if(item.receiptTemplateDataType==1){
                /**系统标签 */
                str = this.defaultInfo.some(v=>v.label==item.key)? this.defaultInfo.find(v=>v.label==item.key).value:'';
            }else{
                str = item.info;
            }
            return str;
        }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/xpSetting.vue